<template>
  <!-- ユーザ編集 -->
  <div id="AppUserManagementEditUserTab">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--ユーザ情報 -->
    <editUserContents ref="editContents" v-bind:selectedid="selectedid" v-bind:is-edit="false" />
  </div>
</template>

<script>
import tabContents from "./AppUserManagementEditUserContents";

export default {
  name: "AppUserManagementEditUserTab",
  methods: {
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      selectedid: userInfo.id
    };
  },
  components: {
    editUserContents: tabContents
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementEditUserTab.vue